import styled from 'styled-components'
import { Text } from '@mprolab/uikit'

export const StyledBiennale = styled(Text)`
  font-family: 'BiennaleBold';
`
